import React, { FC, ReactNode } from 'react'
import { EmploymentHighlighterIcon } from '../EmploymentHighlighterIcon'

export const EmploymentStepIcon: FC<ReactNode> = () => {
  const renderActiveIcon = () => {
    return <EmploymentHighlighterIcon />
  }

  return <div className='icon-container'>{renderActiveIcon()}</div>
}
